export default "__VITE_ASSET__BPLeBsds__"